import React from 'react';
import { Button } from 'antd';

/**
 * @desc 下载文件组件，暂时cdn下载
 * @param {link}[string] 文件链接
 * @param {text}[string] 组件文案
 */
const DownloadLink = ({ link, text, type }) => {
  // 替换腾讯云 cdn 链接格式，picgz 代表压缩，file 代表源文件
  const getFileLink = () => (/picgz/.exec(link) ? link.replace(/picgz/, 'file') : link);
  const handleDownload = () => {
    const downloadLink = document.createElement('a');
    downloadLink.style.display = 'none';
    downloadLink.href = getFileLink();
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  return type === 'button' ? (
    <Button
      onClick={handleDownload}
      type="primary"
      style={{ marginTop: '20px', marginBottom: '8px' }}
    >
      {text}
    </Button>
  ) : type === 'a' ? (
    <a onClick={handleDownload}>{text}</a>
  ) : (
    <Button type="link" onClick={handleDownload}>
      {text}
    </Button>
  );
};

export default DownloadLink;
